<template>
  <footer class="custom-footer-one mt-5 text-center">
    <p class="company-name mx-auto py-3" v-if="quote_data != undefined">{{quote_data.owner.company}}</p>
    <p class="company-name mx-auto py-3" v-else>Nombre de la empresa</p>
  </footer>
</template>
<script>
export default {
  props: {
    settings_style: {
      required: true,
    },
    quote_data:{
      type:Object
    }
  },
};
</script>